import { theme } from '@theme';
import { FC } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import AMLogoMobile from '../../../../assets/svgs/fritz-light.svg';
import logo from '../../../../assets/svgs/logo-marketeyeq-wht.svg';
import { useCheckDevice } from '../../../../hooks/UseCheckDevice';
import { Image } from '../../../style/essential-ui/Image';

type LogoProps = {
  $isStoreSelectHeader?: boolean;
  $isLogoDisabled?: boolean;
};

type LogoWrapperProps = {
  isMobileDevice?: boolean;
};

type LogoImageProps = {
  isMobileDevice?: boolean;
};

const Logo: FC<LogoProps> = (props) => {
  const navigate = useNavigate();
  const goToRoot = () => {
    if (!props.$isLogoDisabled) {
      navigate(`/home/select`);
    }
  };
  const { isMobileDevice } = useCheckDevice();

  return (
    <Wrapper $isStoreSelectHeader={props.$isStoreSelectHeader} data-testid='logo'>
      <LogoWrapper onClick={goToRoot} isMobileDevice={isMobileDevice}>
        <LogoImage
          src={!isMobileDevice ? logo : AMLogoMobile}
          alt='am-logo'
          data-testid='am-logo-img'
          isMobileDevice={isMobileDevice}
        />
      </LogoWrapper>
    </Wrapper>
  );
};

export default Logo;

const Wrapper = styled.div<LogoProps>`
  display: flex;
  flex: 1;
  border-right: ${(props) =>
    props.$isStoreSelectHeader ? `none` : `1px solid ${theme.palette.lightPurpleNine}`};
`;

const LogoWrapper = styled.div<LogoWrapperProps>`
  display: flex;
  cursor: pointer;
  padding-left: 20px;

  ${(props) =>
    props.isMobileDevice &&
    `
    border-right: 1px solid ${theme.palette.darkPurpleSix};
    box-shadow: inset 0px 0px 1px 0px ${theme.palette.toolTipBackground};
    margin-left: -20px;
    padding-left: 10px;
  `}
`;

const LogoImage = styled(Image)<LogoImageProps>`
  width: 170px;
  height: 19px;

  ${(props) =>
    props.isMobileDevice &&
    `
    height: 70px !important;
    width: 45px !important;
    margin-right: 10px;
  `}
`;
